module.exports = __webpack_public_path__ + "img/starglitter.ed01bb91.webp";